'use client';

export default function GlobalSchema() {

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://4patriots.com',
    name: '4Patriots',
    description: '4Patriots is an emergency preparedness brand founded by a husband and wife duo in Nashville, TN. They remain committed to improved self-reliance, freedom, and peace of mind for their customers with high-quality emergency food and equipment. With 4Patriots, you can find an impressive selection of delicious food that\'s all made in the U.S.A. They also offer practical solar and water filtration equipment so you can stay ready for anything.'
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd),
      }}
    />
  );
}
